import $ from 'jquery';
import ClickthroughWidget from './clickthrough-widget';
import FireWorks from './fireworks';
import ZendeskHelp from './zendeskhelp';
import NotifyMe from '../fixtures/notify-me';

export default [
    new ClickthroughWidget('.js-clickthrough-widget'),
    new ZendeskHelp('.help__sections'),
    new FireWorks(),
    $('.js-fixtures-notify-me').length && new NotifyMe(
        '.js-fixtures-notify-me',
    ),
];
